import { Button, CircularProgress, Stack, Typography } from '@mui/material'
import { HourglassEmpty } from '@mui/icons-material'

import AccessGateLayout from './AccessGateLayout'

interface AccessGatePendingProps {
  entityName: string
  message?: string
  onUseAnotherCode: () => void
}

const AccessGatePending: React.FC<AccessGatePendingProps> = ({ entityName, message, onUseAnotherCode }) => {
  return (
    <AccessGateLayout>
      <HourglassEmpty color="primary" sx={{ fontSize: 72 }} />

      <Typography variant="h6" fontWeight={700}>
        Solicitação enviada
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {message ||
          `Sua entrada em ${entityName} depende da aprovação do gestor. Assim que for aprovada, você poderá usar este carregador.`}
      </Typography>

      <Stack direction="row" alignItems="center" spacing={1}>
        <CircularProgress size={14} />
        <Typography variant="caption" color="text.secondary">
          Verificando a aprovação automaticamente...
        </Typography>
      </Stack>

      <Button variant="text" onClick={onUseAnotherCode}>
        Usar outro código
      </Button>
    </AccessGateLayout>
  )
}

export default AccessGatePending
